import { render, staticRenderFns } from "./JSelectJiaocai.vue?vue&type=template&id=31522753&scoped=true"
import script from "./JSelectJiaocai.vue?vue&type=script&lang=js"
export * from "./JSelectJiaocai.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31522753",
  null
  
)

export default component.exports